import {memo} from "react";
import {Handle, NodeProps, Position} from "@xyflow/react";
import {Metric, TreeNode} from "@/types";
import {BasicCardNode, get_color, render_line} from "@/pages/mindmap/CarNodes/BasicCardNode.tsx";
import {formatPercentage} from "@/utils/format.ts";
import {SegmentNode} from "@/pages/mindmap/CarNodes/CategoryCardNode/SegmentNode.tsx";
import {CategoryProvienceNode} from "@/pages/mindmap/CarNodes/CategoryCardNode/CategoryProvienceNode.tsx";
import {CategoryRegionNode} from "@/pages/mindmap/CarNodes/CategoryCardNode/CategoryRegionNode.tsx";


export const CategoryCardNode = memo(({data}: NodeProps) => {
    const node: TreeNode = data.node as any;
    const datas: Record<string, Metric> = node.metrics_map || {};

    const render_common_grid = (
        column_cfgs: { label: string, label2: string, col1_key: string, col2_key: string }[]
    ) => {
        const ContributionRow = ({label, label2, col1_key, col2_key}: {
            label: string,
            label2: string,
            col1_key: string,
            col2_key: string,
        }) => (
            <>
                <div>
                    <span>{label}: </span>
                    <span style={get_color(col1_key, datas)}>
                            {formatPercentage(datas[col1_key]?.value)}
                        </span>
                </div>
                <div>
                    <span>{label2}: </span>
                    <span style={get_color(col2_key, datas)}>
                            {formatPercentage(datas[col2_key]?.value)}
                        </span>
                </div>
            </>
        );
        return <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '2px 12px',
            marginBottom: '2px',
            color: 'rgb(71, 85, 105)'
        }}>
            <div style={{fontWeight: 700, color: 'rgb(30, 41, 59)'}}>IMS Contribution</div>
            <div style={{fontWeight: 700, color: 'rgb(30, 41, 59)'}}>Gap Contribution</div>
            {
                column_cfgs.map((cfg, index) => (
                    <ContributionRow
                        key={"cr-" + index}
                        label={cfg.label}
                        label2={cfg.label2}
                        col1_key={cfg.col1_key}
                        col2_key={cfg.col2_key}
                    />
                ))
            }
        </div>
    }

    const renderDescription = () => {
        if (node.id.endsWith("-region")) {
            // return <>{render_common_grid([
            //     {
            //         label: "Core",
            //         label2: "Core",
            //         col1_key: "core_amt_pct",
            //         col2_key: "core_gap_pct"
            //     },
            //     {
            //         label: "Bm",
            //         label2: "Bm",
            //         col1_key: "bm_amt_pct",
            //         col2_key: "bm_gap_pct"
            //     }
            // ])}</>
            return <CategoryRegionNode node={node}/>
        }
        if (node.id.endsWith("-vbp")) {
            return <div style={{marginLeft: '10px'}}>
                {render_line('ims_vbp', 'ytd', datas)}
                {render_line('ims_vbp', 'mtd', datas)}
            </div>
        }
        if (node.id.endsWith("-nonvbp")) {
            return <div style={{marginLeft: '10px'}}>
                {render_line('ims_nonvbp', 'ytd', datas)}
                {render_line('ims_nonvbp', 'mtd', datas)}
            </div>
        }
        if (node.id.endsWith("-province")) {
            // const params = ["1", "2", "3"].map((rank) => ({
            //     label: datas[`province_amt_rk${rank}`].display,
            //     label2: datas[`province_gap_rk${rank}`].display,
            //     col1_key: `province_amt_rk${rank}_pct`,
            //     col2_key: `province_gap_rk${rank}_pct`
            // }))
            // return <div style={{marginLeft: '10px'}}>
            //     {render_common_grid(params)}
            // </div>

            return <CategoryProvienceNode node={node}/>
        }

        if (node.id.endsWith("-segment")) {
            // const params = ["a", "b", "c"].map((rank) => ({
            //     label: `Seg ${rank.toUpperCase()}`,
            //     label2: `Seg ${rank.toUpperCase()}`,
            //     col1_key: `seg_${rank}_amt_pct`,
            //     col2_key: `seg_${rank}_gap_pct`
            // }))
            // return <div style={{marginLeft: '10px'}}>
            //     {render_common_grid(params)}
            // </div>

            return <SegmentNode node={node}/>
        }

        return <></>
    }


    return <BasicCardNode node={node} isCategory={true} data={data}>
        {renderDescription()}
    </BasicCardNode>


});